// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"88ba6304e3eb4056","931":"af05af442e39310c"}[chunkId] + ".css";
};